/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from "react";
import { StorageModule } from "@vlinder-web/storage-module-react";
//@ts-ignore
import { REACT_APP_BOOTSTRAP } from "@env";
import axios from "axios";
import { useConstructor } from "./constructor.hook";
import { LoggerModule } from "@vlinder-web/logger-module-react";
const is = require("is_js");
import { VApplication } from "../../application";
import { DEFAULT_APP_CONFIG } from "../../config/default.config";

const MODULE_NAME = "bootstrap-hook";
const log: any = LoggerModule?.getInstance({
  visible: false,
});

const deriveCoreServerURL = (config: any) => {
  // If the remote config already provides a coreServer, use it
  if (config?.servers?.rest?.coreServer?.baseURL) {
    return config.servers.rest.coreServer.baseURL;
  }
  // Derive from graphql URL by replacing /graphql/ with /rest/
  const graphqlUrl = config?.servers?.graphql?.[0]?.url;
  if (graphqlUrl) {
    return graphqlUrl.replace(/\/graphql\/?$/, "/rest/");
  }
  // Final fallback to DEFAULT_APP_CONFIG
  return DEFAULT_APP_CONFIG?.servers?.rest?.coreServer?.baseURL;
};

const mergeAppConfig = (config: any = {}) => {
  const coreServerURL = deriveCoreServerURL(config);
  return {
    ...DEFAULT_APP_CONFIG,
    ...config,
    servers: {
      ...DEFAULT_APP_CONFIG?.servers,
      ...config?.servers,
      graphql: config?.servers?.graphql ?? DEFAULT_APP_CONFIG?.servers?.graphql,
      rest: {
        ...DEFAULT_APP_CONFIG?.servers?.rest,
        ...config?.servers?.rest,
        coreServer: {
          baseURL: coreServerURL,
        },
      },
    },
  };
};

const _bootstrapHandler = async () => {
  await bootstrap();
  const vapp = VApplication.getInstance();
  await vapp.start();
  log?.success(MODULE_NAME, `🚀 Main Application Started 🚀`);

  //Do other config here !! Example: Sentry Initialization !!
};

const bootstrap = async () => {
  try {
    const storageService = StorageModule.getInstance();
    const existingConfig = storageService.get("appConfig", "session");

    if (is.existy(existingConfig)) {
      storageService.set("appConfig", mergeAppConfig(existingConfig), "session");
      return;
    }
    if (REACT_APP_BOOTSTRAP) {
      console.log("react app bootstrap", REACT_APP_BOOTSTRAP);
      const kv = await axios.get(REACT_APP_BOOTSTRAP);
      if (kv?.data) {
        storageService.set("appConfig", mergeAppConfig(kv.data), "session");
      }
    } else {
      storageService.set("appConfig", mergeAppConfig(DEFAULT_APP_CONFIG), "session");
    }
  } catch (err: any) {
    console.log("error in bootstrap", err?.message);
    throw Error(`error in bootstrap ${err?.message}`);
  }
};

export const useBootstrap = () => {
  const [bootstrap, setbootstrap] = useState<boolean>(false);

  useConstructor(_bootstrapHandler)
    .then((res) => {
      log.info(`bootstrap check`, res);
      setbootstrap(true);
    })
    .catch((err) => {
      log.error(`error in bootstrap  ${err.message}`);
      setbootstrap(true);
    });

  return { bootstrap };
};
